import React, {PropsWithChildren, useContext} from "react";
import '../../assets/css/Dentobook.css';
import {Link, useNavigate} from "react-router-dom";
import {ExitPromptContext} from "../../context/ExitPromptContext";

interface DentobookLinkProps {
    to: string;
    cssClassName?: string;
    cb?: Function;
}

const DentobookLink = ({to, cssClassName = '', cb, children}: PropsWithChildren<DentobookLinkProps>) => {

    const {isFormDirty, setExitModalOpen, setExitModalAction} = useContext(ExitPromptContext);

    const navigate = useNavigate();

    const handleClick = (e: any) => {
        e.preventDefault();

        if (isFormDirty) {
            setExitModalOpen(true);
            setExitModalAction(to);

            return;
        }

        if (cb) {
            cb();
        }

        navigate(to);
    };

    return (
        <Link to={'/'} className={cssClassName} onClick={handleClick}>{children}</Link>
    );
};

export default DentobookLink;
